module.exports = __webpack_public_path__ + "media/images/consumer/errors/logged-out-error-page-xxs@2x-6fb85b07bd22e18c0290b6f135c0df6a.jpg";